import {API_ENDPOINT as baseUrl} from "../../config";
import {
  authRequest, 
  makeRequest, 
  buildAuthGetPayload,
  buildAuthPostPayload,
  buildAuthPutPayload,
  buildAuthDeletePayload
  } from "./AuthJSONApi";
import {normalize, schema} from "normalizr";
import {Map} from "immutable";

const waterPallet = new schema.Entity("water_pallets", undefined, {
  idAttribute: value => value.pallet_id
});
const stockItems = new schema.Entity("stock_items", undefined, {
  idAttribute: value => value.sku
});
const warehouses = new schema.Entity("warehouses");
const products = new schema.Entity("products", undefined, {
  idAttribute: value => value.code
});
const reponseSchemaWaterPallets = { water_pallets: new schema.Array(waterPallet) }
const responseSchemaWarehouses = { warehouses: new schema.Array(warehouses) }
const responseSchemaProducts = { products: new schema.Array(products) }
const responseSchemaStockItems = { stock_items: new schema.Array(stockItems) }

export function getWaterPallets() {
  const url = `${baseUrl}/production/water_pallets`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, reponseSchemaWaterPallets),
          error: error
        }
      })
  })
}

export function getProducts() {
  const url = `${baseUrl}/products`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, responseSchemaProducts),
          error: error
        }
      })
  })
}

export function getProduct(code) {
  const url = `${baseUrl}/products/${code}`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, products),
          error: error
        }
      })
  })
}


export function getStockItems() {
  const url = `${baseUrl}/products/stock_items`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, responseSchemaStockItems),
          error: error
        }
      })
  })
}

export function getStockItem(sku) {
  const url = `${baseUrl}/products/stock_items/${sku}`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, stockItems),
          error: error
        }
      })
  })
}




export function getWarehouses() {
  const url = `${baseUrl}/warehouses`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, responseSchemaWarehouses),
          error: error
        }
      })
  })
}

export function getWarehouse(id) {
  const url = `${baseUrl}/warehouses/${id}`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, warehouses),
          error: error
        }
      })
  })
}

export function recordWaterTestResult(params = Map()) {
  const pallet_id = params.get("pallet_id");
  const result = params.delete("pallet_id");
  const url = `${baseUrl}/production/water_pallets/${pallet_id}/record_test_result`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      result: result.toJS()
    });
    return makeRequest(url, info);
  })
}

export function renameWarehouse(params = Map()) {
  const warehouse_id = params.get("id");
  const url = `${baseUrl}/warehouses/${warehouse_id}/rename`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      location: params.get("location")
    });
    return makeRequest(url, info);
  })
}

export function changeWarehouseContact(params = Map()) {
  const warehouse_id = params.get("id");
  const url = `${baseUrl}/warehouses/${warehouse_id}/contact`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      contact: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function changeWarehouseAddress(params = Map()) {
  const warehouse_id = params.get("id");
  const url = `${baseUrl}/warehouses/${warehouse_id}/address`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      address: params.toJS()
    });
    return makeRequest(url, info);
  })  
}


export function registerWarehouse(params = Map()) {
  const url = `${baseUrl}/warehouses`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      warehouse: params.toJS()
    });
    return makeRequest(url, info);
  })  
}


export function createProduct(params = Map()) {
  const url = `${baseUrl}/products`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      product: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function addProductVariation(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}/variations`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      variation: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function addProductSize(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}/sizes`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      size: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function createProductConfiguration(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}/configurations`;
  return authRequest(token => {
    const info = buildAuthPostPayload(token, {
      configuration: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function changeProductDescription(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}/description`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      product: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function removeProduct(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}`;
  return authRequest(token => {
    const info = buildAuthDeletePayload(token, {
      product: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

export function addProductToInventory(params = Map()) {
  const url = `${baseUrl}/products/${params.get("code")}/inventory`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      product: params.toJS()
    });
    return makeRequest(url, info);
  })  
}

